<template>
  <div
    ref="input_ref"
    tabindex=0
    class="size-4vh m-x-1v w-100-pct p-1v r1"
    @focus="on_focus()"
    @keyup="on_keypress($event)"
    @click="on_click()"
    @blur="to_blur()">
    <span v-if="is_result">
      {{ result_value }}
    </span>
    <span v-else :class="{blink_after: show_caret, selected: select_all}">
      {{ value_fmt }}
    </span>
  </div>
</template>


<script>

  const BLURMODE = 0
  const FOCUSSELECT = 1
  const SELECTMODE = 2
  const APPENDMODE = 3

  export default{
    props: {
      value: String,
      result_value : String,
      is_result: Boolean,
    },
    data() {
      return {
        value_fmt : '',
        show_caret: false,
        select_all: false,
        cur_state: BLURMODE,
        click_count: 0,
        timer: null
      }
    },
    methods: {
      to_blur() {
        this.show_caret = false
        this.select_all = false
        this.cur_state = BLURMODE
        this.$emit('hidekeypad')
      },
      on_focus() {
        if (this.cur_state === BLURMODE) {
          this.to_focus_select()
          this.$emit('showkeypad')
        }
      },
      to_focus_select() {
        this.show_caret = false
        this.select_all = true
        this.cur_state = FOCUSSELECT
      },
      to_select_mode() {
        this.show_caret = false
        this.select_all = true
        this.cur_state = SELECTMODE
      },
      to_append_mode() {
        this.show_caret = true
        this.select_all = false
        this.cur_state = APPENDMODE
      },
      on_click() {
        this.click_count += 1
        if (this.click_count > 1) {
          this.to_select_mode()
          return
        }
        this.to_next_state()
        this.timer = setTimeout(() => { this.click_count = 0 }, 500)
      },
      to_next_state() {
        switch(this.cur_state) {
          case BLURMODE:
            this.to_select_mode()
            break
          case FOCUSSELECT:
            this.to_select_mode()
            break
          case SELECTMODE:
            this.to_append_mode()
            break
          case APPENDMODE:
            break
        }
      },
      delete_char() {
        if (this.cur_state === BLURMODE) { return }
        const new_value = [SELECTMODE, FOCUSSELECT].includes(this.cur_state) ? '' : this.value.slice(0, -1)
        this.change_value(new_value)
        this.to_append_mode()
      },
      append_num(num) {
        if (this.cur_state === BLURMODE) { return }
        const cur_value = [SELECTMODE, FOCUSSELECT].includes(this.cur_state) ? '' : this.value
        this.change_value(`${cur_value}${num}`)
        this.to_append_mode()
      },
      on_enter_key() {
        if (this.cur_state === BLURMODE) { return }
        this.$refs.input_ref.blur()
      },
      change_value(new_value) {
        this.value_fmt = this.formatNumber(new_value)
        this.$emit('input', new_value)
      },
      on_keypress(key) {
        if (this.cur_state === BLURMODE) { return }
        switch(key.key) {
          case 'Enter':
            this.$refs.input_ref.blur()
            break
          case 'Backspace':
            this.delete_char()
            break
          case '0':
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '6':
          case '7':
          case '8':
          case '9':
            this.append_num(key.key)
            break
        }
      },
      formatNumber (newValue) {
        return newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      simpleNumber (newValue) {
        return newValue.replace(/\D/g, "")
      },
    },
    watch: {
      value: function() {
        this.value_fmt = this.formatNumber(this.value)
      }
    },
    mounted() {
      this.value_fmt = this.formatNumber(this.value)
    },
  }
</script>

<style scoped>
  .size-4vh {
    height: 4vh;
    line-height: 4vh;
    font-size: 4vh;
  }
  .focus { border: 1px solid var(--primary-light2); }
  .selected { background-color: var(--comp-dark); color: var(--white); }
  .blink_after {
    animation: blink-color 1s infinite;
    border-right: transparent solid 1px;
  }
  @keyframes blink-color {
    50% { border-color: #000000; }
  }

</style>